export interface State {}

export function createState(): State {
  return {};
}
